import { styled } from '@mui/material';

import { generateClasses } from '../../utils/helper';

export const noteClasses = {
  ...generateClasses('Note', ['root', 'colorSuccess', 'colorError', 'colorWarning', 'colorInfo', 'icon', 'text']),
};

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(3),
  padding: theme.spacing(4),
  borderRadius: 8,
  [`&.${noteClasses.colorSuccess}`]: {
    backgroundColor: theme.palette.success[50],
    color: theme.palette.success[700],
  },
  [`&.${noteClasses.colorError}`]: {
    backgroundColor: theme.palette.error[50],
    color: theme.palette.error[700],
  },
  [`&.${noteClasses.colorWarning}`]: {
    backgroundColor: theme.palette.warning[50],
    color: theme.palette.warning[700],
  },
  [`&.${noteClasses.colorInfo}`]: {
    backgroundColor: theme.palette.primary[50],
    color: theme.palette.primary[700],
  },
}));

export const Icon = styled('div')(({ theme }) => ({
  display: 'flex',
  /**
   * parent has align-items flex-start to place the icon on top-left even when we have multiple lines of text
   * When we have single-line of text, it looks a bit off-aligned
   * To fix that, we provide this negative margin on icon
   */
  marginTop: theme.spacing(-0.5),
}));
